// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import fetchGraphql from '@/graphql/fetchMutation';
import gql from '@/graphql/gql';
export type ToggleFavouriteMutationVariables = Types.Exact<{
  gameId: Types.Scalars['ID']['input'];
}>;


export type ToggleFavouriteMutation = { __typename?: 'Mutation', casinoToggleFavourite?: { __typename?: 'CasinoToggleFavouritePayload', favouriteGameNode?: { __typename?: 'CasinoGame', id: string, isFavourite?: boolean }, errors?: Array<{ __typename?: 'CasinoError', code?: number, message?: string, params?: Array<{ __typename?: 'CasinoErrorParam', name?: string, value?: string }> }> } };


export const ToggleFavouriteMutationDocument = gql`
    mutation ToggleFavouriteMutation($gameId: ID!) {
  casinoToggleFavourite(input: {gameId: $gameId}) {
    favouriteGameNode {
      id
      isFavourite
    }
    errors {
      code
      message
      params {
        name
        value
      }
    }
  }
}
    `;

export const getToggleFavouriteMutation = async (variables: ToggleFavouriteMutationVariables) => {
  return fetchGraphql<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>(ToggleFavouriteMutationDocument, "ToggleFavouriteMutation", { variables });
}